import React, { useEffect, useState } from "react"
import PageTitle from "../components/PageTitle";
import Index from "../view/Login/Index";
import { validateAll } from "indicative/validator";
import ToastAlert from "../common/ToastAlert";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setLoading, setLogin, setEmailVerified } from "../redux/user/user.action";
import ApiCall from "../common/ApiCall";
import { setBookunWebhook, setFareharborWebhook } from "../redux/global/global.action";
import { getRedirectTo, handoffToSupport } from "../common/supportHandoff";

export default function LoginController() {

    const [state, setState] = useState({
        email: "",
        password: "",
        error: [],
    })
    const [showPassword, setShowPassword] = useState(false);

    const { email, password } = state;
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);

    const location = useLocation();

    // Save redirect once
    useEffect(() => {
        if (location.state?.from) {
            sessionStorage.setItem(
                "postLoginRedirect",
                location.state.from.pathname +
                location.state.from.search +
                location.state.from.hash
            );
        }
        // Came from the support portal → remember it across login (and 2FA).
        if (getRedirectTo() === 'support') {
            sessionStorage.setItem('supportRedirect', '1');
        }
    }, []);


    const login = (e) => {
        if (isLoading) {
            return;
        }
        e?.preventDefault();
        setState({
            ...state,
        })

        const rules = {
            email: 'required|email',
            password: 'required|min:6',

        }

        const message = {
            'email.required': 'Email is Required.',
            'email.email': 'please enter valid email.',
            'password.min': 'The password must contain a minimum of 6 characters.',
            'password.required': 'Password is Required.',

        }
        validateAll(state, rules, message).then(async () => {
            setIsLoading(true)
            setState({
                ...state,
                error: {}
            })
            let data = {}
            data.email = email
            data.password = password

            const authenticate = await ApiCall('post', 'login', data)

            if (authenticate) {

                if (authenticate.data.success) {
                    if (authenticate.data.isEmailVerified) {

                        let dispatchData = {}
                        dispatchData.userDetails = authenticate.data.user

                        // if (!authenticate.data.user?.is_2fa_enabled) {
                        dispatchData.token = authenticate.data.access_token
                        // }

                        dispatchData.tempEmail = authenticate.data.user.email
                        dispatchData.supplierDetails = authenticate.data.supplier
                        dispatchData.is2faEnabled = authenticate.data.user?.is_2fa_enabled
                        dispatchData.permissions = authenticate.data.user?.permissions
                        dispatchData.isWelcomePageEnabled = authenticate.data?.is_welcome_page_enabled;

                        dispatch(setLogin(dispatchData))
                        dispatch(setEmailVerified(true))
                        setIsLoading(false)
                        dispatch(setBookunWebhook(authenticate.data?.isBokunWebhookSetup));
                        dispatch(setFareharborWebhook(authenticate.data?.isFareharborWebhookSetup));

                        if (authenticate.data.user?.is_2fa_enabled) {
                            ToastAlert({ msg: "Please verify 2fa code", msgType: 'info' });
                            navigate('/verify-2fa');
                        } else {
                            ToastAlert({ msg: authenticate.data.message, msgType: 'success' });

                            // Came from support → hand off there instead of the dashboard.
                            if (sessionStorage.getItem('supportRedirect') === '1') {
                                sessionStorage.removeItem('supportRedirect');
                                const ok = await handoffToSupport(authenticate.data.access_token);
                                if (ok) return; // browser is navigating to support
                            }

                            const isWelcomePageEnabled = authenticate.data?.is_welcome_page_enabled;
                            const redirectTo =
                                sessionStorage.getItem("postLoginRedirect") || (isWelcomePageEnabled ? "/information" : "/dashboard");

                            sessionStorage.removeItem("postLoginRedirect");
                            navigate(redirectTo, { replace: true });
                        }



                    } else {
                        let dispatchData = {}
                        dispatchData.userDetails = authenticate.data.user
                        dispatchData.is2faEnabled = authenticate.data.user?.is_2fa_enabled
                        dispatch(setLogin(dispatchData))
                        dispatch(setBookunWebhook(authenticate.data?.isBokunWebhookSetup));
                        dispatch(setFareharborWebhook(authenticate.data?.isFareharborWebhookSetup));
                        ToastAlert({ msg: authenticate.data.message, msgType: 'info' });
                        dispatch(setEmailVerified(false))
                        navigate('/verify')
                        setIsLoading(false)

                    }
                    // let dispatchData = {}
                    // dispatchData.userDetails = authenticate.data.user
                    // dispatchData.token = authenticate.data.access_token
                    // dispatchData.tempEmail = authenticate.data.user.email
                    // dispatchData.supplirerDetails = authenticate.data.supplier

                    // dispatch(setLogin(dispatchData))
                    // if (authenticate.data.user.email_verified_at == "" || authenticate.data.user.email_verified_at == null) {
                    //     dispatch(setEmailVerified(false))
                    //     ToastAlert({ msg: 'Please verify with otp that we sent you in email', msgType: 'info' });
                    //     navigate('/verify')
                    // } else {
                    //     ToastAlert({ msg: authenticate.data.message, msgType: 'success' });
                    //     dispatch(setEmailVerified(true))
                    //     navigate('/home')
                    //     setIsLoading(false)
                    // }
                } else {

                    if (authenticate.data.errors && Object.keys(authenticate.data.errors).length) {

                        setState({
                            ...state,
                            error: authenticate.data.errors,
                        })

                    } else {
                        // ToastAlert({ msg: authenticate.data.message, msgType: 'error' });
                        const formaerrror = {};
                        formaerrror.email = authenticate.data.message
                        setState({
                            ...state,
                            error: formaerrror,
                        })
                    }
                    setIsLoading(false)

                }
            } else {
                setIsLoading(false)
                ToastAlert({ msg: 'Something went wrong', msgType: 'error' });
            }





        }).catch(errors => {
            setIsLoading(false)
            const formaerrror = {};
            if (errors.length) {
                errors.forEach(element => {
                    formaerrror[element.field] = element.message
                });
            } else {
                ToastAlert({ msg: errors?.message ?? 'Something went wrong', msgType: 'error' });
            }

            setState({
                ...state,
                error: formaerrror,
            })

        });

    }

    const changeValue = (e) => {
        let value = e.target.value;
        setState({
            ...state,
            [e.target.name]: value
        })
    }

    const handhandleShowPassword = (e) => {
        e?.preventDefault();
        setShowPassword(!showPassword)
    }

    return (
        <>
            <PageTitle title={'Login'} />
            <Index
                state={state}
                login={login}
                changeValue={changeValue}
                showPassword={showPassword}
                handhandleShowPassword={handhandleShowPassword}
                isLoading={isLoading}
            />
        </>
    )

}